module.exports = __webpack_public_path__ + "img/Frame14.b28d4ad8.png";